module.exports = __webpack_public_path__ + "media/images/pepsi_digin_brunch_lv/mobile-mission-white-bg-19aeb4383a713ac3511d7e6022dd7907.png";